import React, { Component, Fragment } from 'react';
import { Modal } from '@philips-internal/oswald-ui-components';
import { ModalType } from '@philips-internal/oswald-ui-constants';
import { classNames, isMobile } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
class PainScaleReference extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            referenceOpen: false,
        };
    }
    onOpenReferencesModal() {
        this.setState({ referenceOpen: true });
    }
    onCloseReferencesModal() {
        this.setState({ referenceOpen: false });
    }
    render() {
        const { referenceOpen } = this.state;
        const { referenceText, className } = this.props;
        if (!referenceText || (referenceText && !referenceText.length)) {
            return null;
        }
        const referenceLinkClass = classNames({
            'c-pain-scale__reference-link': true,
            [`${className}`]: Boolean(className),
        });
        return (React.createElement(Fragment, null,
            React.createElement("a", { className: referenceLinkClass, onClick: () => this.onOpenReferencesModal() }, MessageService.translate('tws.reference-pain-scale-value')),
            referenceOpen &&
                React.createElement(Modal, { closeable: true, focusOnOpen: true, onClose: () => this.onCloseReferencesModal(), title: MessageService.translate('tws.reference-pain-scale-value'), type: isMobile() ? ModalType.FULLSCREEN : ModalType.DIALOG },
                    React.createElement(Fragment, null, MessageService.translate(referenceText)))));
    }
}
export default PainScaleReference;
//# sourceMappingURL=pain-scale-reference.js.map